import React from "react";
import { SvgIcon } from "@mui/material";

const PaperWithRightCornerBentIcon = ({ color }: any) => {
  const styles = {
    icon: {
      height: 20,
      width: 20
    }
  };

  return (
    <SvgIcon style={styles.icon}>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11.6673 1.89105V5.33317C11.6673 5.79988 11.6673 6.03324 11.7581 6.2115C11.838 6.3683 11.9655 6.49578 12.1223 6.57568C12.3006 6.6665 12.5339 6.6665 13.0007 6.6665H16.4428M16.6673 8.32336V14.3332C16.6673 15.7333 16.6673 16.4334 16.3948 16.9681C16.1552 17.4386 15.7727 17.821 15.3023 18.0607C14.7675 18.3332 14.0674 18.3332 12.6673 18.3332H7.33398C5.93385 18.3332 5.23379 18.3332 4.69901 18.0607C4.2286 17.821 3.84615 17.4386 3.60647 16.9681C3.33398 16.4334 3.33398 15.7333 3.33398 14.3332V5.6665C3.33398 4.26637 3.33398 3.56631 3.60647 3.03153C3.84615 2.56112 4.2286 2.17867 4.69901 1.93899C5.23379 1.6665 5.93385 1.6665 7.33398 1.6665H10.0105C10.6219 1.6665 10.9277 1.6665 11.2154 1.73558C11.4705 1.79682 11.7143 1.89783 11.938 2.0349C12.1903 2.18951 12.4065 2.4057 12.8389 2.83808L15.4957 5.49493C15.9281 5.92731 16.1443 6.1435 16.2989 6.39579C16.436 6.61947 16.537 6.86333 16.5982 7.11842C16.6673 7.40614 16.6673 7.71188 16.6673 8.32336Z"
          stroke="#333333"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

export default PaperWithRightCornerBentIcon;